import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Button } from 'antd';
import {
  FileTextOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { EntryRequest } from '../../types/entry-response';
import {
  CustomButton,
  CustomTable,
  CustomTabs,
  CustomText,
  UploadWithTable,
} from '../../../../components';
import GestorStatusEntry from '../components/ByRoles/GestorStatusEntry';
import { ENTRY_TYPE } from '../../types';
import { formatNumber } from '../../../../utils';
import { useListTerceros } from '../../../../share';

interface EntryRequestDetailViewProps {
  detailData?: EntryRequest;
  setFooterLeft: (footer: React.ReactNode) => void;
  onVoucher?: () => void;
  onDocuments: (id: string) => void;
  onDownloadPDf: (id: string) => void;
  entryStates?: any;
  formikSolicitud?: any;
  handleGestorMyRequest: (opc: boolean, files: any) => void;
  removeFiles?: boolean;
  isApproveRequest?: boolean;
  isModuleApproveRequest?: boolean;
  authData?: any;
}

const EntryRequestDetailView: React.FC<EntryRequestDetailViewProps> = ({
  detailData,
  setFooterLeft,
  onDocuments,
  onDownloadPDf,
  entryStates,
  formikSolicitud,
  handleGestorMyRequest,
  removeFiles,
  isApproveRequest,
}) => {
  const storedToken = localStorage.getItem('auth');
  const parsedToken = storedToken ? JSON.parse(storedToken) : null;
  const token = parsedToken?.authorization?.token;
  const { data } = useListTerceros(token);
    const terceros = data?.third_party || [];
  React.useEffect(() => {
    setFooterLeft(
      <>
        <CustomButton
          label="Descargar documentos"
          disabled={!(detailData?.documents && detailData.documents.length > 0)}
          onClick={() => {
            onDocuments(detailData?.id || '');
          }}
          icon={<DownloadOutlined />}
          size="middle"
          buttonType="secondary"
        />
        <CustomButton
          disabled={detailData?.status_id !== 7}
          style={{ marginLeft: '20px' }}
          label="Generar comprobante"
          onClick={() => {
            onDownloadPDf(detailData?.petition_id || '');
          }}
          icon={<DownloadOutlined />}
          size="middle"
          buttonType="secondary"
        />
      </>
    );
  }, [detailData, setFooterLeft]);
  const [isRoleManage, setIsRoleManage] = useState<any>(null);
  const [files, setFiles] = useState<any>([]);
  const [manageMyRequest, setManageMyRequest] = useState<any>(false);
  const [userLogged, setUserLogged] = useState<any>();
  const [textValue, setTextValue] = useState('');

  const documentColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
  ];
  useEffect(() => {
    setIsRoleManage(false);
    formikSolicitud.resetForm();
    const storage = localStorage.getItem('auth');
    const userData = storage ? JSON.parse(storage).user : null;

    setUserLogged(userData);

    if (isApproveRequest && detailData?.can_manage) {
      setIsRoleManage(detailData?.can_manage);
      setManageMyRequest(false);
    } else if (
      detailData?.status_id === 5 &&
      Number(detailData?.requester_id) === userData.id
    ) {
      setManageMyRequest(true);
      
      setIsRoleManage(false);
      setFiles(detailData?.documents);
    } else {
      setIsRoleManage(false);
      setManageMyRequest(false);
      setFiles([]);
    }
  }, [detailData]);

  useEffect(() => {
    if (
      isApproveRequest ||
      detailData?.status_id === 5 &&
      Number(detailData?.requester_id) === userLogged?.id
    ) {
      handleGestorMyRequest(true, files);
    } else {
      handleGestorMyRequest(false, []);
    }
  }, [files, detailData]);

  useEffect(() => {
    if (removeFiles) {
      setFiles([]);
    }
  }, [removeFiles]);

  const handleTextValue = (opc: any) => {
    setTextValue(opc);
  };

  const handleSupervisor = () => {
    if (detailData?.supervisor) {
      return detailData?.supervisor;
    } else {
      return '';
    }
  };
  const handleContact_person = () => detailData?.contact_person ? detailData?.contact_person : 'Sin registro';
  const handleNit = () => detailData?.contact_nit ? detailData?.contact_nit : 'Sin registro';
  const handleNombre = () => detailData?.contact_name ? detailData?.contact_name : 'Sin registro';
  const handleTelefono = () => detailData?.contact_phone ? detailData?.contact_phone : 'Sin registro';
  const handleValidate_by = () => detailData?.approved_by ? detailData?.approved_by : 'Sin registro';

  return (
    <Fragment>
      {isRoleManage && (
        <GestorStatusEntry
          handleTextValue={handleTextValue}
          entryStates={entryStates}
          detailData={detailData}
          formikSolicitud={formikSolicitud}
          textValue={textValue}
        />
      )}
      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <Button type="link" icon={<FileTextOutlined />}>
                Información general
              </Button>
            ),
            children: (
              <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Solicitante:" strong fontSize="small" />
                    <CustomText
                      text={detailData?.requester}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Tipo de entrada:"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={
                        detailData?.entry_type
                        ? detailData.entry_type.charAt(0).toUpperCase() + detailData.entry_type.slice(1)?.toLowerCase()
                        : ''
                      }
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Cantidad entregas estipuladas" strong fontSize="small" />
                    <CustomText
                      text={String(detailData?.deliveries)}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Seccional entrada:" strong fontSize="small" />
                    <CustomText
                      text={detailData?.entry_section}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Seccional del solicitante:" strong fontSize="small" />
                    <CustomText
                      text={detailData?.requester_section}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Tipo de bien:" strong fontSize="small" />
                    <CustomText
                      text={detailData?.item_type}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Dependencia:" strong fontSize="small" />
                    <CustomText
                      text={detailData?.dependency}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Entrega en otras seccionales:"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={
                        String(detailData?.other_deliver) === '1' ? 'Si' : 'No'
                      }
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Fecha de solicitud:"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={detailData?.query_date}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Estado de solicitud:"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={detailData?.status}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Número de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={detailData?.invoice_number}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Fecha de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe" strong fontSize="small" />
                    <CustomText
                      text={detailData?.invoice_date}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Cantidad de facturas:"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={String(detailData?.invoice_count)}
                      fontSize="middle"
                    />
                  </div>
                </Col>

              {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.ORDEN_COMPRA?.toLowerCase() && (
                  <>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText text="Supervisor:" strong fontSize="small" />
                        <CustomText text={handleSupervisor()} fontSize="middle" />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Número orden de compra:"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.purchase_order}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Rubro presupuestal:"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.budget_item}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}

                {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.CONTRATO?.toLowerCase() && (
                  <>
                   <Col xs={24}>
                      <div className="mb-4 mt-8">
                        <CustomText text="Supervisor:" strong fontSize="small" />
                        <CustomText text={handleSupervisor()} fontSize="middle" />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Número de contrato"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.contract_number ? detailData?.contract_number : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fecha inicio contrato"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.contract_start_date ? detailData?.contract_start_date : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fecha final contrato"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.contract_end_date ? detailData?.contract_end_date : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Rubro presupuestal:"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.budget_item}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}

                {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.DONACION?.toLowerCase() && (
                  <>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Documento de donación"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.donation_document ? detailData?.donation_document :''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}

                {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.COMISO?.toLowerCase() && (
                  <>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Juzgado de conocimiento"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={terceros.find((tercer) => String(tercer.id) === detailData?.judgment_court_name)?.name}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Noticia criminal"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.judgment_process_number ? detailData?.judgment_process_number : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}

                {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.COMODATO?.toLowerCase() && (
                  <>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Número de contrato comodato"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.comodato_contract_number ? detailData?.comodato_contract_number : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fecha inicio de contrato comodato"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.comodato_start_date}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fecha final de contrato comodato"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.comodato_end_date}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}


                {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.ACUERDO_INTERADMINISTRATIVO?.toLowerCase() && (
                  <>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Número de acuerdo interadministrativo"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.interadmin_agreement_number ? detailData?.interadmin_agreement_number : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fecha inicial acuerdo interadministrativo"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.interadmin_start_date}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fecha final acuerdo interadministrativo"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.interadmin_end_date}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}
                
                {detailData?.entry_type?.toLowerCase() === ENTRY_TYPE.INCAUTADO_CON_FINES_DE_COMISO?.toLowerCase() && (
                  <>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Fiscalía"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.decomiso_court_number ? detailData?.decomiso_court_number : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Noticia criminal"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={detailData?.decomiso_process_number ? detailData?.decomiso_process_number : ''}
                          fontSize="middle"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className="mb-4 mt-8">
                        <CustomText
                          text="Valor factura/adquisición/Avalúo/Peritaje"
                          strong
                          fontSize="small"
                        />
                        <CustomText
                          text={`$ ${formatNumber(Number(detailData?.entry_value))}`}
                          fontSize="middle"
                        />
                      </div>
                    </Col>
                  </>
                )}

                <Col xs={24}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Observaciones:" strong fontSize="small" />
                    <CustomText
                      text={detailData?.observations}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                {(
                  ![
                    ENTRY_TYPE.ORDEN_COMPRA?.toLowerCase(),
                    ENTRY_TYPE.CONTRATO?.toLowerCase(),
                  ].includes((detailData?.entry_type || '')?.toLowerCase())
                ) && (
                  <>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="NIT"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={handleNit()}
                        fontSize="middle"
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Nombre"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={handleNombre()}
                        fontSize="middle"
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Persona de contacto"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={handleContact_person()}
                        fontSize="middle"
                      />
                    </div>
                  </Col>

                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Teléfono de contacto"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={handleTelefono()}
                      fontSize="middle"
                    />
                  </div>
                  </>
                )}

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText
                      text="Usuario que atiende la solicitud:"
                      strong
                      fontSize="small"
                    />
                    <CustomText
                      text={handleValidate_by()}
                      fontSize="middle"
                    />
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="mb-4 mt-8">
                    <CustomText text="Motivo" strong fontSize="small" />
                    <CustomText
                      text={textValue || detailData?.reason}
                      fontSize="middle"
                    />
                  </div>
                </Col>
              </Row>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="link" icon={<FileSearchOutlined />}>
                Documentos
              </Button>
            ),
            children: (
              <>
                {manageMyRequest ? (
                  <Row>
                    <Col xs={24}>
                      <UploadWithTable onFilesChange={setFiles} files={files} />
                    </Col>
                  </Row>
                ) : (
                  <CustomTable
                    dataSource={detailData?.documents?.map((doc, index) => ({
                      key: index,
                      createdAt: doc.created_at,
                      name: doc.url?.split('/').pop(),
                      link: doc.url,
                    }))}
                    columns={documentColumns}
                    pagination={false}
                  />
                )}
              </>
            ),
          },
          {
            key: '3',
            label: (
              <Button type="link" icon={<HistoryOutlined />}>
                Historial de la solicitud
              </Button>
            ),
            children: (
              <CustomTable
                columns={[
                  {
                    title: 'Item',
                    dataIndex: 'index',
                    key: 'index',
                    render: (_: any, __: any, index: number) => index + 1,
                  },
                  {
                    title: 'Fecha',
                    dataIndex: 'date',
                    key: 'date',
                  },
                  {
                    title: 'Responsable',
                    dataIndex: 'user',
                    key: 'user',
                    render: (_: any, record: any) => (record.user && record.user_document) ? `${record.user_document} - ${record.user}` : "-"
                  },
                  {
                    title: 'Observaciones',
                    dataIndex: 'observations',
                    key: 'observations',
                  },
                  {
                    title: 'Estado',
                    dataIndex: 'comment',
                    key: 'comment',
                  },
                ]}
                dataSource={detailData?.history?.map((item: any, index) => ({
                  key: index,
                  date: item.date,
                  observations: item.observations,
                  comment: item.comment,
                  user: item.user,
                  user_document: item.user_document,
                }))}
                pagination={false}
              />
            ),
          },
        ]}
      />
    </Fragment>
  );
};

export default EntryRequestDetailView;
